﻿@loginApp =-> new Vue
    el: "#member-login"
    data:
        noError:    true
        submitting: false
        form:
            username:    ""
            password:    ""
            action:      "log_member_in"
        resetName: ''
        showReset: false
        resetSent: false

    computed:
        loginDisabled: ->
            fields = ['', ' ', null]
            @submitting or @form.password in fields or @form.username in fields

        resetDisabled: ->
            fields = ['', ' ', null]
            @submitting or @resetName in fields or @resetSent is 'success'

    methods:
        toggleReset: ->
            @showReset = not @showReset
            @resetName = @form.username

        login: ->
            @submitting = true
            jQuery.ajax
                method:     'post'
                url:        '/wp-admin/admin-ajax.php'
                data:       @form
                success:    (res)-> document.location = "/member/#{res.data}"
                error:      => @noError = false
                complete:   => @submitting = false

        reset: ->
            @submitting = true
            jQuery.ajax
                method:     'post'
                url:        '/wp-admin/admin-ajax.php'
                data:
                    name:   @resetName
                    action: 'reset_password'
                success:    => @resetSent = 'success'
                error:      => @resetSent = "error"
                complete:   => @submitting = false
